import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ServerService} from '../services/ServerService';
import {PriceTableItemVM, PriceTableTargetTypeV2, PriceTableVM, ProductPriceTableRowVM} from './produtos-v2.models';

@Injectable({ providedIn: 'root' })
export class TabelaPrecosService extends ServerService {
  constructor(http: HttpClient) {
    super(http);
  }

  listeTabelas(catalogoId: number, apenasAtivas = false): Promise<PriceTableVM[]> {
    return this.obtenha('/tabela-precos', { cid: catalogoId, ativas: apenasAtivas });
  }

  salveTabela(tabela: PriceTableVM, catalogoId: number): Promise<PriceTableVM> {
    const payload = { ...tabela, catalogoId };
    if (tabela.id) {
      return this.facaPut(`/tabela-precos/${tabela.id}`, payload);
    }
    return this.facaPost('/tabela-precos', payload);
  }

  gereTabelaPadrao(catalogoId: number): Promise<PriceTableVM> {
    return this.facaPost('/tabela-precos/tabela-padrao/gere', { catalogoId });
  }

  removaTabela(tabela: PriceTableVM): Promise<boolean> {
    return this.remova(`/tabela-precos/${tabela.id}`, {});
  }

  listeProduto(produtoId: number, catalogoId: number): Promise<ProductPriceTableRowVM[]> {
    return this.obtenha(`/tabela-precos/produtos/${produtoId}`, { cid: catalogoId });
  }

  salveProduto(produtoId: number, catalogoId: number, itens: PriceTableItemVM[]): Promise<ProductPriceTableRowVM[]> {
    return this.facaPut(`/tabela-precos/produtos/${produtoId}`, { catalogoId, itens });
  }

  listeAlvo(tipoAlvo: PriceTableTargetTypeV2, alvoId: number, catalogoId: number): Promise<ProductPriceTableRowVM[]> {
    return this.obtenha(`/tabela-precos/alvos/${tipoAlvo}/${alvoId}`, { cid: catalogoId });
  }

  salveAlvo(tipoAlvo: PriceTableTargetTypeV2, alvoId: number, catalogoId: number, itens: PriceTableItemVM[]): Promise<ProductPriceTableRowVM[]> {
    return this.facaPut(`/tabela-precos/alvos/${tipoAlvo}/${alvoId}`, { catalogoId, itens });
  }

  listeItens(tabelaId: number, tipoAlvo: string = ''): Promise<PriceTableItemVM[]> {
    return this.obtenha(`/tabela-precos/${tabelaId}/itens`, tipoAlvo ? { tipoAlvo } : {});
  }

  salveItens(tabelaId: number, itens: PriceTableItemVM[]): Promise<PriceTableItemVM[]> {
    return this.facaPut(`/tabela-precos/${tabelaId}/itens`, { itens });
  }

  apliquePrecosPadrao(tabelaId: number, itens: any[]): Promise<PriceTableItemVM[]> {
    return this.facaPost(`/tabela-precos/${tabelaId}/aplicar-precos-padrao`, { itens });
  }
}
